import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const CertHubPage = lazy(() =>
  import('../pages/certification-process/HubPage').then((m) => ({ default: m.HubPage }))
)
const CertProgramDetailPage = lazy(() =>
  import('../pages/certification-process/ProgramDetailPage').then((m) => ({ default: m.ProgramDetailPage }))
)
const CertRequirementsPage = lazy(() =>
  import('../pages/certification-process/RequirementsPage').then((m) => ({ default: m.RequirementsPage }))
)
const CertDocumentsPage = lazy(() =>
  import('../pages/certification-process/DocumentsPage').then((m) => ({ default: m.DocumentsPage }))
)
const CertReadinessPage = lazy(() =>
  import('../pages/certification-process/ReadinessPage').then((m) => ({ default: m.ReadinessPage }))
)

export const certificationProcessRoutes: RouteObject[] = [
  {
    path: 'certification-process',
    children: [
      { index: true, element: <CertHubPage /> },
      { path: 'hub', element: <CertHubPage /> },
      { path: 'program/:programId', element: <CertProgramDetailPage /> },
      { path: 'requirements/:programId', element: <CertRequirementsPage /> },
      { path: 'documents/:programId', element: <CertDocumentsPage /> },
      { path: 'readiness/:programId', element: <CertReadinessPage /> },
    ],
  },
]
